import { Select } from "antd";
import { useEffect, useState } from "react";
import { styled } from "styled-components";

export const SelectAtomic = ({ handleOptionsChange, optionsData, defaultValue, isToDisable, size, fullWidth }) => {
    const [selectedOption, setSelectedOption] = useState(defaultValue);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false); // Track the dropdown open state

    useEffect(() => {
        try {
            // Se as opções mudarem e o defaultValue for um valor válido nas novas opções, atualize o selectedOptio
            if (optionsData?.some(option => option.value === defaultValue)) {
                setSelectedOption(defaultValue);
            }
            // Se o defaultValue não estiver nas opções, você pode definir um valor padrão ou deixar em branco
            else {
                setSelectedOption(optionsData?.[0]?.value);
            }
        } catch (error) {
            console.error('(SelectAtomic page) Error in useEffect when optionsData or defaultValue changed:', error);
            //reportError(error); // Send error report to backend
        }
    }, [optionsData, defaultValue]);

    useEffect(() => {
        try {
            handleOptionsChange(selectedOption);
        } catch (error) {
            console.error('(SelectAtomic page) Error in useEffect selectedOption:', error);
            //reportError(error); // Send error report to backend
        }
    }, [selectedOption])

    return (
        <Select
            listHeight={200}
            size={size ?? 'large'}
            // placeholder={placeholder ?? 'Selecionar opção'}
            options={optionsData}
            onChange={(e, record) => { setSelectedOption(e); handleOptionsChange(e, record) }}
            className={fullWidth ? 'full-width' : ''}
            disabled={isToDisable}
            value={selectedOption}
            // defaultValue={customDefaultValue}
        >
            <Select.Option value={null}>Selecionar...</Select.Option>
            {/* <Select.Option value={null}>Select...</Select.Option>  EN VERSION */}
        </Select>
    );
}
